import { CommonModule } from '@angular/common';
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { GCPImage, ImageCategoryPath, OrderDetails, StoreReceipt } from '../../../constants';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { FirebaseStorageService } from '../../../services/firebase.storage.service';
import { DocumentReference } from '@angular/fire/firestore';
import { FormsModule } from '@angular/forms';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { IftaLabelModule } from 'primeng/iftalabel';
import { ImageModule } from 'primeng/image';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';
import { UtilityService } from '../../../services/utility.service';
import { MessageModule } from 'primeng/message';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
@Component({
    selector: 'app-batch-shopping-complete-tasks',
    imports: [
        AccordionModule,
        CommonModule,
        ButtonModule,
        CardModule,
        FormsModule,
        IftaLabelModule,
        InputTextModule,
        InputNumberModule,
        FileUploadModule,
        ImageModule,
        FloatLabelModule,
        SelectModule,
        MessageModule,
        AutoCompleteModule
    ],
    providers: [MessageService],
    templateUrl: './batch-shopping-complete-tasks.component.html',
    styleUrl: './batch-shopping-complete-tasks.component.scss',
    host: {
        class: 'app-batch-shopping-complete-tasks'
    },
    encapsulation: ViewEncapsulation.None
})
export class BatchShoppingCompleteTasksComponent {
  dynamicDialogRef = inject(DynamicDialogRef);
  dynamicDialogConfig = inject(DynamicDialogConfig);
  firebaseStorageService = inject(FirebaseStorageService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  utilityService = inject(UtilityService);
  order: OrderDetails = {} as OrderDetails;
  storeName: string = '';
  storeOptions: {name: string, code: string}[] = [];
  filteredStoreOptions: {name: string, code: string}[] = [];
  receipts : StoreReceipt[] = [];
  uploadedAllReceipts = false;
  
  constructor() {
    const {order, storeName} = this.dynamicDialogConfig.data;
    this.order = order;
    this.storeName = storeName;

    this.firebaseFirestoreService.subscribeToOrderDetails(this.order.orderDocumentRef as DocumentReference, {
      next: (documentSnapshot) => {
        const orderDetails = documentSnapshot.data() as OrderDetails;
        this.order = {
          ...orderDetails,
          orderId: documentSnapshot.id,
          orderDocumentRef: documentSnapshot.ref
        }
        this.receipts = (orderDetails.storeReceipts || []).filter((r) => r.storeName.split('-')[0] === this.storeName).sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0));
        this.processOrderDetails();
        this.setUploadedAllReceipts();
      },
      complete: () => {},
      error: () => {}
    });
  }

  processOrderDetails() {
    this.storeOptions = [];
    this.storeOptions.push({ name: this.storeName, code: this.storeName });
    if(!this.receipts.find((r) => r.storeName === this.storeName)) {
      this.addReceipt(this.storeName);
    }
    this.filteredStoreOptions = [...this.storeOptions];
  }

  addReceipt(storeName?: string) {
    this.receipts.splice(0,0,{
      storeName: storeName || this.storeName,
      total: 0,
      receiptImage: null
    })
    this.setUploadedAllReceipts();
  }

  async deleteReceipt(receiptIndex: number) {
    const receipt = this.receipts[receiptIndex];
    if(receipt.receiptImage) {
      await this.firebaseStorageService.deleteImage(receipt.receiptImage as GCPImage);
    }
    this.receipts.splice(receiptIndex, 1);
    // const storeReceipts = (this.order.storeReceipts || []).filter((r) => r.storeName !== receipt.storeName);
    await this.firebaseFirestoreService.updateOrderDetails(this.order.orderDocumentRef as DocumentReference, {storeReceipts: this.receipts});
    this.setUploadedAllReceipts();
  }

  async uploadReceipts({files}: {files: Array<File>}, fileupload: FileUpload, receiptIndex: number) {
    for(let i = 0; i < files.length; i++) {
      const data = await this.firebaseStorageService.uploadImage(files[i], ImageCategoryPath.ShoppingReceipts);
      if(data) {
        this.receipts[receiptIndex].receiptImage = data;
        this.receipts[receiptIndex].createdAt = new Date().getTime();
        this.receipts[receiptIndex].createdAtString = new Date().toISOString();
        this.receipts = [...this.receipts];
      }
    }
    fileupload.clear();
    const receipt = this.receipts[receiptIndex];
    // check if receipt already exists
    // const existingReceipt = this.order.storeReceipts?.filter((r) => r.storeName === receipt.storeName);
    // if(existingReceipt?.length) {
    //   receipt.storeName = this.storeName + '-' + (existingReceipt.length + 1);
    // }
    if(receipt.storeName && receipt.total && receipt.receiptImage) {
      await this.saveReceipt(receipt);
    }
  }

  async saveReceipt(receipt: StoreReceipt) {
    await this.firebaseFirestoreService.updateOrderDetails(this.order.orderDocumentRef as DocumentReference, {storeReceipts: [...(this.order.storeReceipts || []), receipt]});
    this.setUploadedAllReceipts();
  }

  setUploadedAllReceipts() {
    this.uploadedAllReceipts = this.receipts.every((r) => r.storeName && r.total && r.receiptImage) && this.receipts.length >= this.storeOptions.length;
  }

  searchStore(event: AutoCompleteCompleteEvent) {
      this.filteredStoreOptions = event.query ? this.storeOptions.filter((store) => store.name.toLowerCase().includes(event.query.toLowerCase())): [...this.storeOptions];
  }

  close() {
    this.dynamicDialogRef.close(this.uploadedAllReceipts);
  }
}
